<!-- 由 suu 创建于 2022-06-24 星期五 -->
<!-- 提交结果 -->
<template>
  <div class="recipe-cna-submit" v-if="info">
    <van-icon class="rcs-icon" size="48" color="#6759FF" name="checked" />
    <div class="rcs-title">提交成功！</div>
    <div class="rcs-sub-title">正在为您生成CNA评估报告..</div>
    <div class="rcs-content">
      <div class="c-item">
        <div class="i-title">用户姓名</div>
        <div class="i-text">{{ info.user_name }}</div>
      </div>
      <div class="c-item">
        <div class="i-title">联系电话</div>
        <div class="i-text">{{ info.phone }}</div>
      </div>
      <div class="c-item">
        <div class="i-title">提交时间</div>
        <div class="i-text">{{ info.add_time }}</div>
      </div>
      <div class="c-tips">
        请耐心等待<span>10分钟</span>，为您量身定制的减脂计划会通过消息告知
      </div>
      <div class="c-btn user-btn" @click="handelClick">知道了</div>
    </div>
    <img
      class="rcs-logo"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
      alt=""
    />
  </div>
</template>

<script>
// 引入微信api
import wx from 'weixin-js-sdk'
export default {
  name: 'recipe-cna-submit',

  components: {},

  props: {},

  data() {
    return {
      info: null
    }
  },

  computed: {
    rid() {
      return this.$route.query.rid
    }
  },

  watch: {},

  created() {
    this.getInfo()
  },

  mounted() {},

  destroyed() {},

  methods: {
    handelClick() {
      // wx.miniProgram.redirectTo({url:'/package-recipe/pages/questionnaire/list/index'});
      // app中
      if (this.$betterwe.isApp()) {
        if (this.$route.query.sfrom === 'weVip') {
          window.history.back()
        } else {
          window.history.go(-2)
        }
      } else {
        wx.miniProgram.navigateBack()
      }
    },
    /**
     * 获取问卷提交信息
     */
    getInfo() {
      this.$toast.loading('加载中...')
      this.$http
        .getBaseApp('member/AppCamp/getCNAScheme', {
          rid: this.rid
        })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.info = res.data.data
            // this.info = {
            //   name: '婷婷',
            //   phone: '13875996214',
            //   date: '2021年7月16日 18:56:06'
            // }
          } else {
            this.$toast(res.msg)
          }
          this.$toast.clear()
        })
        .catch(() => {
          this.$toast.clear()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.recipe-cna-submit {
  width: 100vw;
  min-height: 100vh;
  background-color: #f7f7f7;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  .rcs-icon {
    margin-top: 58px;
  }
  .rcs-title {
    font-size: 20px;
    font-weight: bold;
    color: #000000;
    margin-top: 16px;
  }
  .rcs-sub-title {
    font-size: 13px;
    font-weight: 500;
    color: #1d1d23;
    margin-top: 5px;
  }
  .rcs-content {
    margin-top: 25px;
    width: 330px;
    padding: vw(30);
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 10px;
    .c-item {
      width: 100%;
      padding: 0 vw(20);
      font-size: 12px;
      font-weight: 500;
      color: #202025;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 32px;
    }
    .c-item:nth-child(odd) {
      background: #f6f7f8;
    }
    .c-tips {
      font-size: 12px;
      font-weight: 400;
      color: #808080;
      margin-top: 20px;
      span {
        color: #6759ff;
      }
    }
    .c-btn {
      width: 280px;
      height: 44px;
      border-radius: 22px;
      border: 1px solid #f1f1f1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: AlibabaPuHuiTiM;
      color: #000000;
      font-weight: 600;
      margin-top: vw(22);
    }
  }
  .rcs-logo {
    width: 93px;
    margin-top: 155px;
  }
}
</style>
